var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0501 19.825C9.85843 19.825 7.99801 19.0646 6.46885 17.5437C4.93968 16.0229 4.1751 14.1583 4.1751 11.95V11.7L2.5501 13.325L1.2251 12L5.1251 8.125L9.0001 12L7.6751 13.325L6.0501 11.7V11.95C6.0501 13.625 6.63135 15.0437 7.79385 16.2063C8.95635 17.3688 10.3751 17.95 12.0501 17.95C12.4751 17.95 12.8897 17.9042 13.2938 17.8125C13.698 17.7208 14.1001 17.5792 14.5001 17.3875L15.9001 18.7875C15.2918 19.1375 14.6647 19.3979 14.0188 19.5688C13.373 19.7396 12.7168 19.825 12.0501 19.825ZM18.8751 15.825L15.0001 11.95L16.3251 10.625L17.9501 12.25V12C17.9501 10.325 17.3688 8.90625 16.2063 7.74375C15.0438 6.58125 13.6251 6 11.9501 6C11.5251 6 11.1105 6.04583 10.7063 6.1375C10.3022 6.22917 9.9001 6.37083 9.5001 6.5625L8.1001 5.1625C8.70843 4.8125 9.33552 4.55208 9.98135 4.38125C10.6272 4.21042 11.2834 4.125 11.9501 4.125C14.1418 4.125 16.0022 4.88542 17.5313 6.40625C19.0605 7.92708 19.8251 9.79167 19.8251 12V12.25L21.4501 10.625L22.7751 11.95L18.8751 15.825Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReupload);
export default __webpack_public_path__ + "static/media/icon-reupload.04fcc51179d968bd38b6f128372e4e89.svg";
export { ForwardRef as ReactComponent };